import React from 'react';
import useFirebase from '../../../hooks/useFirebase';

import './MyProfile.css';

const MyProfile = () => {
  // Email, Phone Number
  const { user, logout } = useFirebase();

  console.log(user);
  return (
    <div>
      <h1 className="heading" data-aos="zoom-out-up" data-aos-duration="1000" data-aos-easing="ease-in-sine"
        gutterBottom>
        <span>M</span>
        <span>Y</span>
        <span className="space">{""}</span>
        <span>P</span>
        <span>R</span>
        <span>O</span>
        <span>F</span>
        <span>I</span>
        <span>L </span>
        <span>E </span>

      </h1>
      <div className="bio">
        <div className="profile-image">
          <img src={user.photoURL} alt="" width="100px" />
        </div>
        <div className="ms-5 mt-5">
          <h3 className="bio-text">{user.displayName}</h3>

          <div className="d-flex">
            <div className="user-email px-3 py-2 text-bolder mt-4 rounded-pill me-4 text-lowercase">
              <i className="fas fa-envelope"></i> {user.email}
            </div>
            <button
              onClick={logout}
              className="user-email px-3 py-2 text-bolder mt-4 rounded-pill me-4">
              <i className="fas fa-sign-out-alt"></i> Log Out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;